import newrelic from '../../newrelic';

// purpose of this component is to keep track of the current active account id and send that information over to new relic
export const NewRelicTracker = ({ accountId }) => {
  newrelic.setCustomAttribute('Active Account', accountId);
  return null;
};

export default NewRelicTracker;
